import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { appsettings } from '../shared/app.settings';
import { Category } from '../category/category.model';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs';
import { Product } from '../product/product.model';

@Injectable()
export class CategoryService {
  public category = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    const routeParams = this.route.snapshot.params;
  }

  categoriesUrl = appsettings.rootUrl + 'tr/tr/category';
  productsUrl = appsettings.rootUrl + 'tr/tr/category';


  getCategories(country: string, language: string) {
    console.log(appsettings.rootUrl + country + '/' + language + '/category')
    return this.http
      .get<Category[]>(appsettings.rootUrl + country + '/' + language + '/category')
      .map(
        (categories) => {
          return categories;
        });
  }

  getCategory(link: string, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/category/' + link, {
        responseType: 'json'
      });
  }
  
  getCategoryById(id: number, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/categorybyid/' + id, {
        responseType: 'json'
      })
      .map(
        (categories) => {
          return categories['categories'];

        });
  }
  
  getChildCategory(link: string, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/category/' + link, {
        responseType: 'json'
      })
      .map(
        (categories) => {
          return categories['categories'];

        });
  }

  getProducts(link: string, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/category/' + link, {
        responseType: 'json'
      });
  }

  getProduct(link: string, country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/category/' + link, {
        responseType: 'json'
      })
      .map(
        (products) => {
          return products;

        });
  }

  getProductsHome(country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/product')
      .map(
        (product) => {
          return product;
        },
        error => console.log('Error ::' + error)
      );
  }

  getAll(country: string, language: string) {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/category')
      .map(
        (category) => {
          return category;
        });
  }
}